import Terminal from "./Terminal";

export default function Homepage() {
    return (
        <div className='main-content'>
            <Terminal />
        </div>
    )
}
